// extracted by mini-css-extract-plugin
export var container = "_8v-0";
export var containerTopRight = "_8v-1";